import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const base = API_BASE_URL;

const handle = (err, fallback) => {
    if (err.response?.data) throw err.response.data;
    throw err.message || fallback;
};

export const getVendorsByType = async ({ VendorType }) => {
    try {
        const res = await axios.get(`${base}/Reports/GetVendorsbyType`, { params: { VendorType } });
        return res.data;
    } catch (err) { return handle(err, 'Failed to fetch vendors'); }
};

export const getCCByVendor = async ({ VendorCode, VendorType, CCStatusval }) => {
    try {
        const res = await axios.get(`${base}/Reports/GetCCByVendor`, { params: { VendorCode, VendorType, CCStatusval } });
        return res.data;
    } catch (err) { return handle(err, 'Failed to fetch cost centres'); }
};

export const getPOForInvoiceReport = async ({ VendorCode, VendorType, CCCode, FromDate, ToDate }) => {
    try {
        const res = await axios.post(`${base}/Reports/GetPOForInvoiceReport`, { VendorCode, VendorType, CCCode, FromDate, ToDate });
        return res.data;
    } catch (err) { return handle(err, 'Failed to fetch PO numbers'); }
};

export const getVendorInvoices = async ({ VendorCode, VendorType, ReportCC, ReportPO, FromDate, ToDate }) => {
    try {
        const res = await axios.post(`${base}/Reports/GetVendorInvoices`, { VendorCode, VendorType, ReportCC, ReportPO, FromDate, ToDate });
        return res.data;
    } catch (err) { return handle(err, 'Failed to fetch vendor invoice report'); }
};

export const getVendorInvoiceDetailSummary = async ({ VendorCode, VendorType, CCCode, PONo, InvoiceNo, CompanyGST, VendorGST }) => {
    try {
        const res = await axios.get(`${base}/Reports/GetVendorInvoiceDetailSummary`, {
            params: { VendorCode, VendorType, CCCode, PONo, InvoiceNo, CompanyGST, VendorGST },
        });
        return res.data;
    } catch (err) { return handle(err, 'Failed to fetch invoice detail'); }
};

export const getSupplierInvoiceSummary = async ({ VendorCode, VendorType, CCCode, PONo, InvoiceNo, MRRNo, CompanyGST, VendorGST }) => {
    try {
        const res = await axios.get(`${base}/Reports/GetSupplierInvoiceSummary`, {
            params: { VendorCode, VendorType, CCCode, PONo, InvoiceNo, MRRNo, CompanyGST, VendorGST },
        });
        return res.data;
    } catch (err) { return handle(err, 'Failed to fetch invoice detail'); }
};
